import classNames from 'classnames';
import React from 'react';
import type { ReactNode } from 'react';

import { MediaSizeEnum, type MediaGalleryProps } from '../../types';
import Media from '../Medias/Media';
import { MediaListWrapper } from '../UI';

const MediaList: React.FC<MediaGalleryProps> = ({ mediaList, mediaSize, className, hideSection, renderMedia, ...rest }) => {
  const isThumbnail = mediaSize === MediaSizeEnum.THUMBNAIL;

  const medias: ReactNode = mediaList.map((media, index) => {
    const hideQuickDelete = !rest.onDelete || !isThumbnail;
    const key = media.data?.id ?? media.data?.uploadId ?? media.id ?? media.uuid ?? String(index);
    const mediaProps = { key, index, media, hideQuickDelete };
    return renderMedia?.({ ...mediaProps, ...rest }) ?? <Media {...mediaProps} {...rest} key={mediaProps.key} />;
  });

  return hideSection ? medias : (
    <MediaListWrapper className={classNames(['media-list', mediaSize], className)}>{medias}</MediaListWrapper>
  );
};

export default MediaList;
